import { useEffect, useState } from 'react';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntry from '@/pages/home/components/CategoryEntry';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import LatestUpdates from '@/pages/home/components/LatestUpdates';
import SidePanel from '@/pages/home/components/SidePanel';
import SiteIntro from '@/pages/home/components/SiteIntro';
import { readHistory } from '@/utils/storage';
import { applySeo } from '@/utils/seo';

export default function Home() {
  const [historyIds, setHistoryIds] = useState<string[]>([]);

  useEffect(() => {
    applySeo({
      title: '同学的妈妈影视大全与剧情介绍',
      description:
        '同学的妈妈网站提供丰富的影视资源和详细剧情介绍，涵盖电影、电视剧等多种类型，满足用户全方位的观影需求。',
      keywords:
        '同学的妈妈,影视大全,剧情介绍,电影推荐,电视剧资源,影视资讯',
      path: '/',
    });
    setHistoryIds(readHistory().map((item) => item.id));
  }, []);

  return (
    <div>
      <HeroCarousel />

      <div className="px-4 md:px-8 lg:px-12">
        <h1 className="sr-only">同学的妈妈影视大全与剧情介绍</h1>
        <div className="mt-6 md:mt-8">
          <CategoryEntry />
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:mt-10 lg:grid-cols-12 lg:gap-8">
          <div className="flex flex-col gap-8 lg:col-span-8 lg:gap-10">
            <FeaturedSection />
            <div className="lg:hidden">
              <LatestUpdates />
            </div>
          </div>
          <div className="lg:col-span-4">
            <SidePanel historyIds={historyIds} />
            <div className="mt-4 hidden lg:block">
              <LatestUpdates />
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12">
          <SiteIntro />
        </div>
      </div>
    </div>
  );
}